/* eslint-disable */

// Request-specific action types for state management

// Table and Row Management
export const SET_SELECTED_ROW = 'REQUEST_LIST/SET_SELECTED_ROW';
export const SET_API_DATA = 'REQUEST_LIST/SET_API_DATA';

// Loading States
export const SET_LOADING = 'REQUEST_LIST/SET_LOADING';

// Drawer Management
export const SET_DRAWER_OPEN = 'REQUEST_LIST/SET_DRAWER_OPEN';
export const SET_REQUEST_ID = 'REQUEST_LIST/SET_REQUEST_ID';

// Filter Management
export const SET_CURRENT_FILTERS = 'REQUEST_LIST/SET_CURRENT_FILTERS';
export const CLEAR_ALL_FILTERS = 'REQUEST_LIST/CLEAR_ALL_FILTERS';
export const DELETE_FILTER = 'REQUEST_LIST/DELETE_FILTER';

// State Reset
export const RESET_REQUEST_STATE = 'REQUEST_LIST/RESET_REQUEST_STATE';

// Form Management
export const SET_FILTER_FORM_DATA = 'REQUEST_LIST/SET_FILTER_FORM_DATA';
export const UPDATE_FILTER_FIELD = 'REQUEST_LIST/UPDATE_FILTER_FIELD';

// Additional Table Actions
export const SET_CURRENT_ROW = 'REQUEST_LIST/SET_CURRENT_ROW';
export const SET_RENDER_COUNT = 'REQUEST_LIST/SET_RENDER_COUNT';
export const SET_TABLE_REF = 'REQUEST_LIST/SET_TABLE_REF';

// Root Level State Management
export const SET_CURRENT_STATUS_FILTER = 'REQUEST_LIST/SET_CURRENT_STATUS_FILTER';
export const SET_CURRENT_RENDER_COUNT = 'REQUEST_LIST/SET_CURRENT_RENDER_COUNT';
export const SET_REQUEST_API_URL = 'REQUEST_LIST/SET_REQUEST_API_URL';
export const SET_INSTRUMENT_FILTER = 'REQUEST_LIST/SET_INSTRUMENT_FILTER';

// API Management
export const SET_API_LOADING = 'REQUEST_LIST/SET_API_LOADING';
export const SET_API_ERROR = 'REQUEST_LIST/SET_API_ERROR';
export const CLEAR_API_ERROR = 'REQUEST_LIST/CLEAR_API_ERROR';